module.exports = __webpack_public_path__ + "img/lock.6b4ee43f.svg";